<template>
    <div class="modal-overlay" @click.self="cancel">
      <div class="modal">
        <h2>Supprimer l’association</h2>
        <p>Voulez-vous vraiment supprimer <strong>"{{ nom }}"</strong> ?</p>
        <div class="actions">
          <button class="btn btn-confirm" @click="confirm">Oui, supprimer</button>
          <button class="btn btn-cancel" @click="cancel">Annuler</button>
        </div>
      </div>
    </div>
</template>
<script>
  export default {
    name: 'DeleteAssociationModal',
    props: {
      nom: { type: String, required: true }
    },
    emits: ['confirm', 'cancel'],
    methods: {
      confirm() {
        this.$emit('confirm');
      },
      cancel() {
        this.$emit('cancel');
      }
    }
  }
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  
  .modal {
    background: #fff;
    border-radius: 8px;
    padding: 2rem;
    max-width: 400px;
    width: 90%;
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
    text-align: center;
  }
  
  .actions {
    display: flex;
    justify-content: space-around;
    margin-top: 1.5rem;
  }
  
  .btn {
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.2s;
  }
  
  .btn-confirm {
    background-color: #B82828;
    color: white;
  }
  
  .btn-confirm:hover {
    background-color: #9e1f1f;
  }
  
  .btn-cancel {
    background-color: #ccc;
    color: #333;
  }
  
  .btn-cancel:hover {
    background-color: #b3b3b3;
  }
  </style>
  